import React, { useState } from 'react';
import AdminCRUD from '../../components/admin/AdminCRUD';
import I18nForm from '../../components/admin/I18nForm';

const TeamForm = ({ initialData, onSave, onCancel }) => {
  const d = initialData || {};
  const [form, setForm] = useState({
    name:     d.name     || '',
    role:     d.role     || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    bio:      d.bio      || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    image:    d.image    || '/images/default-avatar.jpg',
    linkedin: d.linkedin || '',
    twitter:  d.twitter  || '',
    order:    d.order    || 0,
    isActive: d.isActive !== false,
  });

  const inputStyle = { width: '100%', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '8px 10px', fontSize: '13px', color: '#334155', outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#475569', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' };

  return (
    <form onSubmit={e => { e.preventDefault(); onSave(form); }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '14px' }}>
        <div>
          <label style={labelStyle}>Name</label>
          <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Order</label>
          <input type="number" value={form.order} onChange={e => setForm(f => ({ ...f, order: Number(e.target.value) }))} style={inputStyle} />
        </div>
      </div>

      <I18nForm label="Role / Title" value={form.role} onChange={v => setForm(f => ({ ...f, role: v }))} />
      <I18nForm label="Bio" value={form.bio} onChange={v => setForm(f => ({ ...f, bio: v }))} multiline rows={4} />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
        <div>
          <label style={labelStyle}>LinkedIn URL</label>
          <input value={form.linkedin} onChange={e => setForm(f => ({ ...f, linkedin: e.target.value }))} style={inputStyle} placeholder="https://linkedin.com/in/..." />
        </div>
        <div>
          <label style={labelStyle}>Image URL</label>
          <input value={form.image} onChange={e => setForm(f => ({ ...f, image: e.target.value }))} style={inputStyle} />
        </div>
      </div>

      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', cursor: 'pointer', marginBottom: '20px' }}>
        <input type="checkbox" checked={form.isActive} onChange={e => setForm(f => ({ ...f, isActive: e.target.checked }))} />
        Active
      </label>

      <div style={{ display: 'flex', gap: '10px' }}>
        <button type="submit" style={{ background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>Save</button>
        <button type="button" onClick={onCancel} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', cursor: 'pointer' }}>Cancel</button>
      </div>
    </form>
  );
};

const COLUMNS = [
  { key: 'name', label: 'Name' },
  { key: 'role', label: 'Role (EN)', render: item => item.role?.en || '' },
  { key: 'order', label: 'Order' },
  { key: 'isActive', label: 'Active', render: item => item.isActive ? '✅' : '❌' },
];

const AdminTeam = () => (
  <AdminCRUD title="Team Members" apiPath="/api/admin/team" columns={COLUMNS} FormComponent={TeamForm} />
);

export default AdminTeam;
